import { Button, Col, Form, Row, Spin } from "antd";
import { useAddApiUserApi } from "features/users/apis/useAddApiUserApi";
import styles from "./styles.module.scss";
import EnglishInput from "features/common/components/Forms/formItems/stringInputs/EnglishInput";
import PermissionSection from "../Permissions/PermissionsSection";
import { UsersSliceActions } from "features/users/redux/slices/usersSlice";
import {
  useAppDispatch,
  useAppSelector,
} from "features/common/hooks/useReduxHooks";
import { useEffect, useState } from "react";
import { useFetchApiPermissionsApi } from "features/users/apis/useFetchApiPermissionsApi";

const AddApiUserSection = () => {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const { permissions } = useAppSelector((state) => state.users.add.api);
  const [permissionsData, setPermissionsData] = useState<any>([]);
  const { isLoading, mutateAsync } = useAddApiUserApi();
  const { data, isLoading: permissionsLoading } = useFetchApiPermissionsApi();
  const onFinish = (values: any) => {
    const formData = new FormData();
    formData.append("name", values.name);
    permissions.forEach((permission, index) => {
      formData.append(`permissions[${index}]`, `${permission}`);
    });
    mutateAsync(formData);
  };
  useEffect(() => {
    if (data) {
      console.log(data.sub_features);
      setPermissionsData(
        data?.sub_features?.map((feat: any) => {
          return {
            feat: feat?.key,
            permissions: feat?.permissions,
          };
        })
      );
    }
  }, [data]);
  return (
    <>
      <Spin
        spinning={isLoading || permissionsLoading}
        wrapperClassName={styles.formContainer}
      >
        <Col span={24} >
          <Form
            form={form}
            onFinish={onFinish}
            labelCol={{ span: 24 }}
            className={styles.form}
          >
            <Row gutter={32}>
              <Col className={styles.col} xs={24}>
                <EnglishInput
                  name={"name"}
                  label={<div className="label">User Name</div>}
                />
              </Col>
              <Col className={styles.col} span={24}>
                <PermissionSection
                  permissionsData={permissionsData}
                  selectedPermissions={permissions}
                  onChange={(value) => {
                    dispatch(
                      UsersSliceActions.SetPermissionsAction([
                        "add",
                        "api",
                        value,
                      ])
                    );
                  }}
                />
              </Col>
            </Row>
          </Form>
        </Col>
        <Col
          span={4}
          className={styles.col}
          style={{ marginInlineStart: "auto" }}
        >
          <Button
            size="large"
            type="primary"
            shape="round"
            block
            onClick={() => form.submit()}
            loading={isLoading}
          >
            Save
          </Button>
        </Col>
      </Spin>
    </>
  );
};

export default AddApiUserSection;
